import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function AddProjetoBairro() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
   
    Bairro:'',
    Zona:'',
    Descricao:'',
    Tipo:'',
    Fonte:'',
    Valor: '',

  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .post('/api/addprojetobairro', form)
      .then((res) => {
        if (res.data.Status === 'Success') {
          alert('Projeto criado com sucesso!');
          navigate('/');
        } else {
          alert('Erro ao criar Projeto');
        }
      })
      .catch((err) => {
        console.error(err);
        alert('Erro no servidor');
      });
  };

  return (
    <div className="px-4 py-3">
      <h3 className="mb-4">Adicionar Novo Projeto por Bairro</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Bairro</label>
          <input
            type="text"
            name="Bairro"
            className="form-control"
            required
            value={form.Bairro}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Zona</label>
          <input
            type="text"
            name="Zona"
            className="form-control"
            required
            value={form.Zona}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Descrição</label>
          <textarea
            name="descricao"
            className="form-control"
            required
            value={form.Descricao}
            onChange={handleChange}
          ></textarea>
        </div>

        <div className="mb-3">
          <label>Tipo</label>
          <input
            name="tipo"
            className="form-control"
            required
            value={form.Tipo}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Fonte</label>
          <input
            name="fonte"
            className="form-control"
            required
            value={form.Fonte}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Valor</label>
          <input
            name="valor"
            className="form-control"
            required
            value={form.Valor}
            onChange={handleChange}
          />
        </div>

 

        <button type="submit" className="btn btn-primary">
          Salvar PCA
        </button>
      </form>
    </div>
  );
}

export default AddProjetoBairro;
